export const images = {
    airline_logo: require('../icons/Malaysia-Airlines-Logo-and-wordmark.png'),
    arrow_up: require('../icons/arrow_up_green.png'),
    arrow_down: require('../icons/arrow_down_red.png'),
    download: require('../icons/download.svg'),
    ellipsis_loader: require('../icons/loaders/ellipsis-loader.svg'),
    under_maintenance: require('../icons/Under maintenance.png'),
}

